var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.loading)?_c('div',{staticClass:"hero"},[_c('div',{staticClass:"container text-wrapper"},[_c('h2',[_vm._v(_vm._s(_vm._f("unMachine")(_vm.pageTitle)))]),_c('p',[_vm._v(_vm._s(_vm.pageIntroText))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }